import { PATIENT_STATUS } from '../../../shared/constants';
import { ISchedulingValues } from '../../pages/SchedulingPage/components/schedulingWizard';
import { MONTHS_ITEMS } from './constants';

export function getMonth(month: string | undefined) {
  return month ? MONTHS_ITEMS.find(({ id }) => month === id) : undefined;
}

export const currentYear = new Date().getFullYear();

export function patientFormHasError(errors: Record<string, any>) {
  return !!(
    errors.contactGivenName ||
    errors.contactFamilyName ||
    errors.patientBirthDate ||
    errors.patientGivenName ||
    errors.patientFamilyName ||
    errors.contactBirthDate ||
    errors.contactEmail
  );
}

export function infoFormCompleted(values: ISchedulingValues): boolean {
  const { bookingForAnother } = values;
  let contactValid = true;
  const insuranceIssuerCheck =
    !values.office?.insuranceCoverageEnabled ||
    (values.insuranceIssuer && values.providerInsuranceCoverage);
  if (bookingForAnother) {
    contactValid = !!(
      values.contactGivenName &&
      values.contactFamilyName &&
      values.contactBirthMonth &&
      values.contactBirthDay &&
      values.contactBirthYear
    );
  }
  return !!(
    values.patientGivenName &&
    values.patientFamilyName &&
    values.patientBirthMonth &&
    values.patientBirthDay &&
    values.patientBirthYear &&
    insuranceIssuerCheck &&
    contactValid
  );
}

export function insuranceInfoFormCompleted(values: ISchedulingValues): boolean {
  return !!(values.memberId &&
  values.group &&
  values.employer &&
  values.subscriberGivenName &&
  values.subscriberFamilyName &&
  values.subscriberBirthDate &&
  values.subscriberPostalCode &&
  values.patientStatus?.id === PATIENT_STATUS.NEW
    ? values.subscriberSsn
    : true);
}

export const constructBirthDay = (day: string, month: string, year: string) =>
  `${year}-${month}-${day.padStart(2, '0')}`;
